import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MenuItem } from '../views/layout/sidebar/menu.model';
import { StorageService } from './storage.service';
import { AuthService } from './auth.service';
import { AlertService } from './alert.service';
import { InactivityService } from '../_helpers/inactivity-check-service';

@Injectable({
  providedIn: 'root',
})
export class MenusService {
  private menuData: MenuItem[] = [];
  private menuSource = new BehaviorSubject(this.menuData);
  currentMenus = this.menuSource.asObservable();

  constructor(
    private storageService: StorageService,
    private authService: AuthService,
    private alertService: AlertService,
    private inactivityService: InactivityService
  ) {}

  changeMenus(menuData: MenuItem[]) {
    this.menuSource.next(this.BindMenuVariable(menuData));
  }

  BindMenuVariable(menuData: MenuItem[]) {
    return menuData;
  }

  transformApiResponse(apiResponse: any[]): any[] {
  return apiResponse.map(node => {
    return {
      MenuName: node.nodeName,
      MenuLink: node.nodeInfo?.menuLink || "",
      PMenuId: node.parentId === null || node.parentId === undefined || node.parentId === 1 ? 0 : node.parentId,
      permissionID: node.originalNodeId?.toString() || "",
      MenuId: node.nodeId,
      Position: node.nodeInfo?.position !== undefined && node.nodeInfo?.position !== null ? Number(node.nodeInfo.position) : null,
      PermissionAction: node?.nodeInfo?.action || "",
      Icon: node?.nodeInfo?.icon || "grid",

    };
  });

  }

  structuredMenu(menuArray: any[], pMenuId?: any) {
    let finalMenus = [];
    let sidebarMenus: any = [];
    console.log(menuArray)

    const level1 = menuArray.filter((m) => m.PMenuId === (pMenuId || 0)).sort((a, b) => {
      // Sort by position if both have it
      if (a.Position !== null && b.Position !== null) {
        return a.Position - b.Position;
      }
      // Items with position come first
      if (a.Position !== null) return -1;
      if (b.Position !== null) return 1;
      // Otherwise sort alphabetically by name
      return (a.MenuName || '').localeCompare(b.MenuName || '');
    })
    finalMenus.push(...level1);
    sidebarMenus.push(...level1.map((m) => {
      return {
        id: m.MenuId,
        label: m.MenuName,
        title: m.Title,
        link: m.MenuLink,
        icon: m.Icon || 'home'
      }
    }));
    sidebarMenus = sidebarMenus.map((m: any) => {
      m['subItems'] = menuArray
      .filter((ml) => ml.PMenuId === m.id).sort((a, b) => {
        // Sort by position if both have it
        if (a.Position !== null && b.Position !== null) {
          return a.Position - b.Position;
        }
        // Items with position come first
        if (a.Position !== null) return -1;
        if (b.Position !== null) return 1;
        // Otherwise sort alphabetically by name
        return (a.MenuName || '').localeCompare(b.MenuName || '');
      })
      .map((m) => {
        return {
          id: m.MenuId,
          label: m.MenuName,
          link: m.MenuLink,
        };
      });
      return m;
    });

    finalMenus = finalMenus.map((m) => {
      m['children'] = menuArray.filter((ml) => ml.PMenuId === m.MenuId);
      return m;
    });

    finalMenus = finalMenus.map((m1) => {
      m1['children'] = m1.children.map(
        (m2: { [x: string]: any[]; MenuId: any }) => {
          m2['children'] = menuArray.filter((ml) => ml.PMenuId === m2.MenuId);
          return m2;
        }
      );
      return m1;
    });

    sidebarMenus = sidebarMenus.map((m1: any) => {
      m1['subItems'] = m1['subItems'].map((m2: any) => {
        m2['subItems'] = menuArray
        .filter((ml) => ml.PMenuId === m2.id).sort((a, b) => {
          // Sort by position if both have it
          if (a.Position !== null && b.Position !== null) {
            return a.Position - b.Position;
          }
          // Items with position come first
          if (a.Position !== null) return -1;
          if (b.Position !== null) return 1;
          // Otherwise sort alphabetically by name
          return (a.MenuName || '').localeCompare(b.MenuName || '');
        })
        .map((m) => {
          return {
            id: m.MenuId,
            label: m.MenuName,
            title: m.Title,
            link: m.MenuLink,
            icon: m.Icon || 'home',
          };
        });
        return m2;
      });
      return m1;
    });
    return { finalMenus, sidebarMenus, rawMenus: menuArray };
  }

  saveMenusItems(menuArray: any) {
    this.storageService.saveMenuItems(menuArray);
  }

  getMenusItems(): any {
    const menusItems = this.storageService.getMenuItems();
    if (menusItems) {
      return menusItems;
    } else {
      return this.authService.getProfile().subscribe(
        (data) => {
          const { Menu } = data;
          const structMenu = this.structuredMenu(
            this.transformApiResponse(data.data)
          );
          this.saveMenusItems(structMenu);
          if (structMenu.finalMenus[0].ROLENAME == 'Reseller') {
            // if (structMenu.finalMenus[0].ROLENAME =="Reseller"||structMenu.finalMenus[0].ROLENAME =="Merchant" )
            this.alertService.errorAlert({
              title: 'No Access! Contact Administrator',
              backdrop: true,
              toast: true,
              timer: 2000,
              position: 'top-end',
            });
            this.inactivityService.stopInactivityTracking();
            this.authService.logout();
          }
          return structMenu;
        },
        () => {
          return;
        }
      );
    }
  }

  getPermissions(path: string): any {
    if (path.charAt(0) === '#') {
      path = path.slice(1);
    }
    if (path.indexOf(';') > -1) {
      path = path.substr(0, path.indexOf(';'));
    }

    path = path.split('?')[0];
    const data = this.getMenusItems();
    const { rawMenus } = data;
    if (rawMenus) {
      const currentMenuDetails = rawMenus?.find(
        (m: any) => m.MenuLink === path
      );
      console.log(currentMenuDetails, '===============>');
      return currentMenuDetails?.PermissionAction || '';
    } else {
      return;
    }
  }
}
